import { css } from "@emotion/core";

import { drawerWidth, miniDrawerWidth } from "../styles/variables";

// eslint-disable-next-line import/prefer-default-export
export const content = css`
  margin-left: ${drawerWidth};
`;

export const contentExpanded = css`
  margin-left: ${miniDrawerWidth};
`;
